import pro1 from "../assests/samatva.png";
import Pro2 from "../assests/aayush.png";
import pro3 from "../assests/metaverse.png";
const ProjectCardData =[
    {
        imgsrc:pro1,
        title:"Samatva.Ai",
        text:"Samatva.Ai - Creating Equal Opportunities For Differently Abled",
        view:"https://www.theoptimistcitizen.com/samatva/"
        
    },
{
    imgsrc:Pro2,
    title:"Aayush",
    text:"Aayush - The Future of Healthcare is Here",
    view:"https://yourstory.com/2018/10/healthcare-innovator-aayush-wins-accenture-innovation-challenge",
    
},
{
    imgsrc:pro3,
    title:"Metaverse",
    text:"Metaverse - Gated Community House Project",
    view:"https://www.spatial.io/s/MERESTONE-636ce500c9db410001ae5ff6?share=2192308067457270880",
    
}
]
export default ProjectCardData;